import TerminosCondiciones from "@/views/TerminosCondiciones.vue";

const terminosCondiciones = {
  path: "/terminosCondiciones",
  name: "terminosCondiciones",
  component: TerminosCondiciones,
};

export default terminosCondiciones;
